import React from 'react';

function FriendItem({ friend }) {

  const { url, image, name, description } = friend

  return (
    <a href={url} target="_blank" rel="noopener">
      <img src={'images/friend/' + image} alt={name}
           className="circle"/>
      <span className="performance-title">{name}</span>
      <p>{description}<br/>{url}</p>
    </a>
  );

}

export default FriendItem;



/** WEBPACK FOOTER **
 ** ./src/components/Friends/FriendItem.js
 **/